import React, { Component } from "react";
import axios from "axios";
import { BASE_URL, CLIENTS, HEADERS } from "../../common/api";
import Table from "../../assets/js/Table";

const columns = [
  { field: "name", header: "Имя" },
  { field: "phone", header: "Номер телефона" },
  { field: "region__nameUz", header: "Регион" },
];

export class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    axios
      .get(BASE_URL + CLIENTS, HEADERS)
      .then((res) => this.setState({ data: res.data }));
  }
  render() {
    const { data } = this.state;
    return (
      <>
        <Table
          data={data}
          columns={columns}
          title="Клиенты"
          // editFunc={(row) => this.get(row)}
          // deleteFunc={(event, id) => this.showConfirmationModal(event, id)}
          // filterFunc={(event, id) => this.filter(event, id)}
        />
      </>
    );
  }
}

export default Client;
